import { Pipe, PipeTransform} from "@angular/core";

@Pipe( {name : 'queueTaskPipe'})

export class QueueTaskTimePipe  implements PipeTransform {

  dateTask: number | any;
  dateNow: number | any;
  diffHr: number | any;
  diffMin: number | any;

constructor() {

}
  transform(value: any, args?: any): any {

    // Get the date
    const date = new Date(value);

    if (!date.getTime()) {
      return '-';
    }

    // Value is not a number
    if (!value) {
      return '-';
    }

    // diff two dates in Minutes
    this.dateTask = new Date(value);
    this.dateNow = new Date(Date.now());
    const diffMs = (this.dateNow - this.dateTask); // the Result is in milliseconds
    this.diffHr = Math.floor(diffMs / 3600000); // hours
    this.diffMin = Math.round((diffMs % 3600000) / 60000); // will be converted to minutes

    if (this.diffHr === 0) {
      return this.diffMin + ' min';
    } else {
      return this.diffHr + 'h ' + this.diffMin + 'min';
    }
  }
}


